import { ProviderConfig, WILDCARD } from "../types";

export const defaultConfig: ProviderConfig = {
  allowedRoutes: WILDCARD,
  allowedFeatures: WILDCARD,
};
